
/****************** TILE CONFIGURATION *****************/
//hard coded variables:
export const side = 75 //width and length of a tile
export const topStart = 0;
export const leftStart = 0;

//logic variables:
export const evenLeftStart = leftStart + side * 0.5;
export const leftIncrementor = side - 0.9; //incrementor 
export const topIncrementor = side * 0.73; //incrementor 

/****************** TOKEN CONFIGURATION *****************/